import React, { FC, useState } from "react";
import { useDocumentTitle } from "hooks/useDocumentTitle";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import toast from "react-hot-toast";
import { globalJson } from "global/global_json";
import { ContactFun } from "api/profile/profile";
import RentalPolicies from "components/RentalPolicies/RentalPolicies";

export interface PageContactProps {
  className?: string;
  asSection?: boolean;
}

const contacts = [
  {
    id: 1,
    icon: (
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3291 3.08238C11.2367 1.19716 9.29636 0.0454051 7.13864 0.0013895C7.04653 -0.000508942 6.95383 -0.000508942 6.86168 0.0013895C4.704 0.0454051 2.76366 1.19716 1.67121 3.08238C0.554581 5.00936 0.52403 7.32405 1.58948 9.2742L6.05302 17.4441C6.05502 17.4477 6.05703 17.4513 6.0591 17.4549C6.25548 17.7962 6.60729 18 7.00023 18C7.39314 18 7.74495 17.7962 7.9413 17.4549C7.94337 17.4513 7.94537 17.4477 7.94738 17.4441L12.4109 9.2742C13.4763 7.32405 13.4457 5.00936 12.3291 3.08238ZM7.00016 8.15623C5.60442 8.15623 4.46891 7.02072 4.46891 5.62498C4.46891 4.22925 5.60442 3.09373 7.00016 3.09373C8.3959 3.09373 9.53141 4.22925 9.53141 5.62498C9.53141 7.02072 8.39594 8.15623 7.00016 8.15623Z"
          fill="#050B20"
        />
      </svg>
    ),
    title: "Office Location",
    detail: globalJson.address,
  },
  {
    id: 2,
    icon: (
      <svg
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.2947 14.3934C15.3734 14.4945 15.4289 14.6037 15.4604 14.7211C15.5039 14.8837 15.5014 15.0464 15.4526 15.2107C15.4041 15.3744 15.3118 15.5146 15.1763 15.6306L14.5373 16.1685C14.2869 16.3745 14.0266 16.5452 13.7565 16.6805C13.4863 16.8158 13.2053 16.9228 12.913 17.0011C12.443 17.1271 11.9579 17.1733 11.4573 17.1399C10.9568 17.1066 10.458 17.0003 9.96106 16.8216C9.46412 16.6428 8.97654 16.396 8.49896 16.0817C8.02126 15.767 7.5689 15.3948 7.14261 14.9644C6.88214 14.7323 6.60174 14.463 6.30099 14.1565C6.04587 13.8953 5.74995 13.5799 5.41271 13.2099C5.07558 12.8403 4.72397 12.4235 4.35738 11.9608C3.98561 11.4991 3.67933 11.091 3.43896 10.7362C3.19848 10.381 3.00618 10.084 2.8629 9.8449C2.69529 9.5657 2.56626 9.32234 2.47591 9.11523C2.24941 8.74634 2.05474 8.37119 1.8923 7.98966C1.72986 7.60813 1.59674 7.22281 1.49263 6.83426C1.35649 6.32618 1.27666 5.82383 1.25249 5.32649C1.22832 4.82915 1.26788 4.35003 1.37033 3.88938C1.47278 3.42873 1.64325 2.99556 1.88175 2.58989C2.12025 2.18422 2.43383 1.82226 2.82227 1.50316L3.45396 0.97856C3.55455 0.899549 3.66213 0.84492 3.77617 0.814365C3.93666 0.771361 4.09805 0.775646 4.26046 0.827643C4.42244 0.879752 4.55927 0.974815 4.67021 1.11348L6.90043 3.89053C6.97955 3.99155 7.03418 4.09914 7.06474 4.21317C7.10966 4.38084 7.10812 4.54738 7.05967 4.71291C7.01123 4.87844 6.91823 5.01789 6.78013 5.13094L5.53035 6.16836C5.36518 6.30541 5.25511 6.4707 5.19952 6.66531C5.14435 6.8598 5.14242 7.05361 5.19425 7.24704C5.23363 7.39402 5.29809 7.52477 5.38816 7.6396L9.16027 12.3565C9.30703 12.5376 9.47383 12.655 9.6615 12.7083C9.84875 12.7618 10.0379 12.7632 10.2279 12.7123C10.3576 12.6775 10.4819 12.6125 10.6009 12.5177L11.8506 11.4803C11.9501 11.4021 12.0567 11.3472 12.1707 11.3167C12.3279 11.2746 12.4884 11.2791 12.6521 11.3308C12.8158 11.3824 12.954 11.4762 13.0666 11.6126L15.2947 14.3934Z"
          fill="#050B20"
        />
      </svg>
    ),
    title: "Phone",
    detail: globalJson.phone,
  },
  {
    id: 3,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1305_3549)">
          <path
            d="M17.8418 3.57594L12.3828 8.99981L17.8418 14.4237C17.9405 14.2174 18.0004 13.9894 18.0004 13.7459V4.25372C18.0004 4.01019 17.9405 3.7822 17.8418 3.57594Z"
            fill="#050B20"
          />
          <path
            d="M16.418 2.67188H1.58207C1.33855 2.67188 1.11056 2.73175 0.904297 2.83043L7.88151 9.7725C8.49843 10.3894 9.50165 10.3894 10.1186 9.7725L17.0958 2.83043C16.8895 2.73175 16.6615 2.67188 16.418 2.67188Z"
            fill="#050B20"
          />
          <path
            d="M0.158555 3.57594C0.0598711 3.7822 0 4.01019 0 4.25372V13.7459C0 13.9894 0.0598711 14.2175 0.158555 14.4237L5.61758 8.99981L0.158555 3.57594Z"
            fill="#050B20"
          />
          <path
            d="M11.6368 9.74576L10.8643 10.5182C9.83634 11.5462 8.16371 11.5462 7.13578 10.5182L6.36332 9.74576L0.904297 15.1696C1.11056 15.2683 1.33855 15.3282 1.58207 15.3282H16.418C16.6615 15.3282 16.8895 15.2683 17.0958 15.1696L11.6368 9.74576Z"
            fill="#050B20"
          />
        </g>
        <defs>
          <clipPath id="clip0_1305_3549">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Email",
    detail: globalJson.email,
  },
];

const PageContact: FC<PageContactProps> = ({
  className = "",
  asSection = false,
}) => {
  useDocumentTitle(asSection ? undefined : "Contact");
  const [getEmail, setEmail] = useState("");
  const [newName, setNewName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!getEmail.trim() || !emailRegex.test(getEmail)) {
      toast.error("Please enter a valid email address");
      setLoading(false);
      return;
    }

    if (getEmail.length === 0 || newName.length === 0 || message.length === 0) {
      toast.error("Fields are required!");
      setLoading(false);
      return;
    }

    // Create the payload with name, email, and message
    const companyPayload = {
      company:
        process.env.REACT_APP_ENV !== "prod"
          ? globalJson.dev_company_id
          : globalJson.prod_company_id,
      name: newName,
      email: getEmail,
      message: message,
    };
    const renterPayload = {
      name: newName,
      email: getEmail,
      message: message,
    };

    const result = await ContactFun(companyPayload);
    const result1 = await ContactFun(renterPayload);

    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("Sent successfully!");
      setEmail("");
      setNewName("");
      setMessage("");
    }

    setLoading(false);
  };

  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <div className="container mx-auto">
        <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-12  rounded-lg py-16 px-12">
          <div className="mt-8 ">
            <h2 className="text-5xl font-medium">
              Have questions?
              <br /> Get in touch!
            </h2>
            <div className="flex flex-col mt-6">
              <div className=" space-y-6">
                {contacts.map((contact) => (
                  <div key={contact.id} className="flex items-center space-x-4">
                    {/* Icon */}
                    <div className="flex items-center justify-center  ">
                      {contact.icon}
                    </div>

                    {/* Text */}
                    <div>
                      <p className="text-[#121212] text-sm font-medium">
                        {contact.detail}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <div className="py-4"></div>
            <form className="grid grid-cols-1 gap-6" onSubmit={sendEmail}>
              <label className="block">
                <Input
                  placeholder="Name"
                  type="text"
                  className="mt-1"
                  value={newName}
                  onChange={(e) => {
                    setNewName(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Input
                  type="email"
                  placeholder="Email"
                  className="mt-1"
                  value={getEmail}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </label>
              <label className="block">
                <Textarea
                  className="mt-1"
                  placeholder="Message"
                  rows={6}
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                />
              </label>
              <div>
                <ButtonPrimary type="submit" className="min-w-[200px]">
                  {loading ? (
                    <div className="flex justify-center items-center col-span-full">
                      <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                    </div>
                  ) : (
                    "Send Message"
                  )}
                </ButtonPrimary>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="container relative py-16">
        <RentalPolicies />
      </div>
    </div>
  );
};

export default PageContact;
